import NumberParameterValue from "../api/models/test-series/NumberParameterValue";
import EnumParameterValue from "../api/models/test-series/EnumParameterValue";
import TextParameterValue from "../api/models/test-series/TextParameterValue";
import { WhiteChip } from "../components/Chip/WhiteChipTooltip";
import ParameterValue from "../api/models/test-series/ParameterValue";

export default function extractValueAndUnitCode(parameterValue: ParameterValue): WhiteChip {
  let value;
  let unitCode;
  switch (parameterValue.type) {
    case "NUMBER": {
      const numberParameterValue = parameterValue as NumberParameterValue;
      value = numberParameterValue.value?.toString();
      unitCode = numberParameterValue.unitCode?.toString();
      break;
    }
    case "ENUM": {
      value = (parameterValue as EnumParameterValue).value?.toString();
      break;
    }
    case "TEXT": {
      value = (parameterValue as TextParameterValue).value?.toString();
      break;
    }
    default:
      break;
  }

  return {
    value,
    unitCode,
  };
}
